/* eslint-disable no-unused-vars, no-param-reassign */

/*
 * This function removes non-standard props from DOM elements
 * It also sets `value` to empty (when null) for controlled components
 * For details, see https://fb.me/react-unknown-prop
 */
export const domOnlyProps = ({
  active,
  autofill,
  autofilled,
  dirty,
  error,
  initialValue,
  invalid,
  onUpdate,
  pristine,
  touched,
  valid,
  visited,
  ...domProps,
}) => {
  if (domProps.value === null) {
    domProps.value = ''
  }
  return domProps
}



/** WEBPACK FOOTER **
 ** ./src/utils/dom-only-props/dom-only-props.js
 **/